import React from 'react';

const Challenger: React.FC = () => (
    <div className="App-content">
      <h2>The Challenger Sale</h2>
      <iframe 
        width="52%"
        height="550px"
        frameBorder={"0"}
        allowFullScreen={true}
        src="https://app.eisengard.ai/shared_canvas_module.html?remote_moduleid=YiOyPP86RHSs0zWWz2kDfA">        
      </iframe>
    </div>
);

export default Challenger;